<template>
<div class="subject-box">
  <div class="subject-box-title">
    <div class="title-left">
      <p class="china-title">{{currentQuestionList1.tips_cnname}}</p>
      <p class="en-title">{{currentQuestionList1.tips_enname}}</p>
    </div>
    <div class="title-right" v-if="currentQuestionList1.has_audio==1">
      <div class="audio-add" @click="playAudio">
        <div class="audio-box" style="position:relative;z-index:10;"></div>
        <audio class="audio" id="audioPlay" ref="audio" controls :src="currentQuestionList1.question_audio" autoplay ></audio>
      </div>
    </div>
  </div>
  <div class="subject-content-box">
    <div class="subject-content drage-type">
      <div class="word-box" v-html="currentQuestionList1.question_title"></div>
      <div class="isHasImg" v-if="currentQuestionList1.has_img==1">
        <img :src="currentQuestionList1.question_titleimg" style="max-width: 300px;" alt />
      </div>
      <div class="img-drag">
        <!-- :options="{group:{name: falgs,pull:'clone'},filter: '.undraggable', sort: false}" -->
        <div class="img-drag-source" style="margin-bottom:10px">
          <vuedraggable :list="list2" :options="{group:{name: falgs,pull:'clone'}, sort: false}" @end="end" id="dragArea" class="dragArea">
            <div v-for="(element,index) of list2" :key="index" :class="{undraggable : element.flag}" class="list-complete-item">
              <div class="list-complete-item-handle">
                <div class="imgs-box">
                  <img :src="element.answers_optionimg" alt />
                  <span class="num">{{element.answers_optionname}}</span>
                </div>
              </div>
            </div>
          </vuedraggable>
        </div>
        <div class="img-drag-target img-drag-target-add">
          <vuedraggable :list="list1" :options="{group:{name:'article',}, disabled: disabled}" id="dragArea11" class="dragArea">
            <div class="imgs-box imgs-box-add">
              <img :src="targetImg" class="area-img" alt />
              <span class="answerArea">{{$t('Evaluation.AnsweringArea')}}</span>
            </div>
          </vuedraggable>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import vuedraggable from "vuedraggable";
export default {
  name: "DragType",
  props: {
    currentQuestionList: {
      type: Object
    },
     //当前点击到 第几题
    currentId: {
      type: Number
    },
    //当前题目答案格式
    anwsersAll: {
      type: Object
    },
    //所有题目答案格式
    anwsersListAll:{
      type: Array
    },
    //  propIndex:{
    //   type: Number
    // },
    propChild: {
      type: Object
    },
  },
  components: {
    vuedraggable
  },
  data() {
    return {
      currentQuestionList1: {},
      question: {
        word: "<br/>Matt:$B$<br/>Chevady:It is Saturday!Let is go out and play."
      },
      falgs: "article",
      disabled: false,
      list1: [
        // { id: 1, name: '作答区域' },
        // { id: 2, name: '作答区域' },
        // { id: 3, name: '作答区域' },
        // { id: 4, name: '作答区域' },
      ],
      list2: [
        // {
        //   id: 1,
        //   name: 1,
        //   img:
        //     "https://oss.kidcastle.cn/examine/HOB/HOB-U1/HOB-U1-0031/OptionB.jpg"
        // },
        // {
        //   id: 2,
        //   name: 2,
        //   img:
        //     "https://oss.kidcastle.cn/examine/HOB/HOB-U1/HOB-U1-0031/OptionD.jpg"
        // },
        // {
        //   id: 3,
        //   name: 3,
        //   img:
        //     "https://oss.kidcastle.cn/examine/HOB/HOB-U1/HOB-U1-0031/OptionA.jpg"
        // },
        // {
        //   id: 4,
        //   name: 4,
        //   img:
        //     "https://oss.kidcastle.cn/examine/HOB/HOB-U1/HOB-U1-0031/OptionC.jpg"
        // }
      ],
      targetImg: '',
      targetImgReplace:'',
      anwsersListAllReplace:[],
    };
  },
  watch: {
    getData(n, o) {
      console.log(22222);
      // console.log(n, o,'我接收到的数据');
      this.currentQuestionList1 = n;
      this.list2 = n.option;
      let index = this.currentId;
      // if(this.anwsersListAllReplace[index].hasOwnProperty("img")){//如果有图片这个属性
      //   this.targetImg = this.anwsersListAllReplace[index].img;
      // }else{
      //   this.targetImg = '';
      // }
      if(this.anwsersListAllReplace.length>0){
        if(this.anwsersListAllReplace[index].hasOwnProperty("img")){//如果有图片这个属性
          this.targetImg = this.anwsersListAllReplace[index].img;
        }else{
          this.targetImg = '';
        }
      }else{
        this.targetImg = '';
      }
      console.log(this.anwsersListAllReplace)
      console.log(this.currentQuestionList1, '我接收到的数据-----000000')

      console.log(this.currentId,this.anwsersListAllReplace[this.currentId],'哈哈哈哈------000000--->>>')
    },
    getData1(n, o) {
      console.log(22222);
      // console.log(n, o,'我接收到的数据');
      this.currentQuestionList1 = n;
      this.list2 = n.option;
      // this.list1 = [];
      console.log(this.currentQuestionList1, '我接收到的数据')
    },
    quetionClick(n, o) {
      console.log( this.anwsersListAllReplace[index],'哈哈哈哈--------->>>')
      let index = this.currentId;
      if(n>o){//下一题
        console.log('下一题')
        if(this.anwsersListAllReplace[index].hasOwnProperty("img")){//如果有图片这个属性
          this.targetImg = this.anwsersListAllReplace[index].img;
        }else{
          this.targetImg = '';
        }
        console.log(this.anwsersListAllReplace)
      }else{//上一题
        console.log('上一题')
        // console.log(index)
        // console.log(this.anwsersListAllReplace[index].img)
        //  console.log(this.anwsersListAllReplace)
        this.targetImg = this.anwsersListAllReplace[index].img;
      }
    }
  },
  computed: {
    getData() {
      return this.currentQuestionList;
    },
    getData1() {
      return this.propChild;
    },
    quetionClick() {
      return this.currentId;
    }
  },
  created() {
    this.anwsersListAllReplace =[];
    this.anwsersListAllReplace = Array.from(this.anwsersListAll);
    this.currentQuestionList1 = this.propChild?this.propChild:this.currentQuestionList;
  },
  // props: ['title'],
  methods: {
    playAudio() {
      console.log(333);
      let audio = this.$refs.audio;
      audio.play();
    },
    // 源 结束
    end(ev) {
      console.log(ev);
      console.log(ev.to.id);
      console.log(ev.to.className);
      let propValue='';
      let _this = this;
      if (ev.to.id === "dragArea11") {
        console.log(ev.oldIndex, "oldIndex");
        console.log(this.list2[ev.oldIndex], '当前拖拽的')
        this.$set(this.list2[ev.oldIndex], "flag", true);
        console.log(this.list1, "目标");

        propValue = this.list1[0].answers_optionname;
        this.anwsersAll.answers = this.list1[0].answers_optionname;

        let index = this.currentId;
        this.anwsersListAllReplace =[];
        this.anwsersListAllReplace = Array.from(this.anwsersListAll);
        this.anwsersListAllReplace[index].img = this.list1[0].answers_optionimg;
        console.log('我是赋值之后的数组',this.anwsersListAllReplace)
        let imgs = this.list1[0].answers_optionimg;

        this.targetImg = this.list2[ev.oldIndex].answers_optionimg;
        // this.targetImgReplace = this.list2[ev.oldIndex].answers_optionimg;
        this.list1 = [];
        console.log(this.list1[0])
        // let myList = [...this.anwsersListAll];

        

        // this.anwsersListAllReplace.forEach(function(item){
        //   console.log(item)
        //   item.img = imgs;
        // })
      }

      console.log(propValue)
      this.$emit('dragClickChange',propValue)
    },
  }
};
</script>

<style lang="less">
.drage-type {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .word-box {
    font-size: 15px;
    color: #333333;
    margin-top: 10px !important;
    margin-bottom: 20px !important;
  }

  .isHasImg {
    // max-width: 100px;
    margin: 20px auto;
    text-align: center;
    img {
      width: 100%;
    }
  }

  .img-drag {
    .dragArea {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      .list-complete-item {
        // width: 180px;
        // height: 180px;
        border-radius: 8px;
        border: 1px solid rgba(221, 221, 221, 1);
        transition: all 1s;
        cursor: pointer;
        margin-right: 25px;
        margin-bottom: 25px;

        &:last-child {
          margin-right: 0;
        }

      }

      .imgs-box {
        width: 140px;
        height: 140px;
        position: relative;

        img {
          width: 100%;
          max-height: 100%;
          border-radius: 8px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
        }

        .num {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 30px;
          color: #ffffff;
          font-weight: bold;
        }

        .answerArea {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 16px;
          color: #333;
          font-weight: bold;
          z-index: 1;
        }
      }

      .imgs-box-add {
        width: 140px;
        height: 140px;
        border: 1px solid #dddd;
        border-radius: 8px;
      }
    }
  }

  .Answer-area {
    border-bottom: 1px solid #dddd;
    padding-bottom: 15px;
    text-align: center;
  }
}

// .img-drag-target-add .list-complete-item .sortable-ghost{
//   opacity: 0;
// }
.img-drag-target-add .list-complete-item {
  transform: none !important;
  width: 0 !important;
  height: 0 !important;
  opacity: 0 !important;
}
</style>
